import React, { useState, useEffect } from 'react';
import aboutFood from '../../assets/about/fervent-ferment-fermentation.jpg';
import aboutProfile from '../../assets/about/fervent-ferment-david-lavergne-aboutProfile.jpg';
import separatorLogo from '../../assets/traiteur/separatorLogo.svg';

function AboutContent() {
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/content/about/about.json');
        const data = await response.json();
        setAboutData(data);
      } catch (error) {
        console.error('Error fetching about data:', error);
      }
    };

    fetchData();
  }, []);

  const highlightTerms = ['expérience gastronomique unique', 'transforme', 'vivant', 'la nature'];
  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const quoteRegex = new RegExp(
    `(${highlightTerms.map(escapeRegExp).join('|')})`,
    'gi'
  );

  const renderHighlightedQuote = (quote = '') =>
    quote.split(quoteRegex).map((part, index) =>
      highlightTerms.includes(part.toLowerCase()) ? (
        <span key={index}>{part}</span>
      ) : (
        <React.Fragment key={index}>{part}</React.Fragment>
      )
    );

  if (!aboutData) {
    return <div></div>;
  }

  return (
    <>
      <div className="aboutWrapper">
        {/* Notre passion section */}
        <div className="aboutTop">
          <div>
            <h3 className="aboutSectionTitle">{aboutData.passion.title}</h3>
            <p className='aboutTopText'>{aboutData.passion.paragraphe_1}</p>
            <p className='aboutTopText strucMarginTop'>{aboutData.passion.paragraphe_2}</p>
            <p className='aboutTopText strucMarginTop'>{aboutData.passion.paragraphe_3}</p>
            <div className="aboutCitation">
              <p>"{renderHighlightedQuote(aboutData.passion.quote)}"</p>
            </div>
          </div>
          <img src={aboutFood} alt="" className="aboutImg" />
        </div>

        {/* Notre démarche section */}
        <div className="aboutBottom">
          <p className='aboutBottomText aboutMobile aboutSectionTitle'>{aboutData.demarche.title}</p>
          <p className='aboutBottomText aboutMobile'>{aboutData.demarche.paragraphe_1}</p>
          <p className='aboutBottomText aboutMobile strucMarginTop'>{aboutData.demarche.paragraphe_2}</p>
          <p className='aboutBottomText aboutMobile strucMarginTop'>{aboutData.demarche.paragraphe_3}</p>
          <div className="aboutCitation aboutMobile">
            <p>"{renderHighlightedQuote(aboutData.demarche.quote)}"</p>
          </div>
          <img src={aboutProfile} alt="" className="aboutImg" />
          <div>
            <h3 className='aboutBottomText aboutDesktop aboutSectionTitle'>{aboutData.demarche.title}</h3>
            <p className='aboutBottomText aboutDesktop'>{aboutData.demarche.paragraphe_1}</p>
            <p className='aboutBottomText aboutDesktop strucMarginTop'>{aboutData.demarche.paragraphe_2}</p>
            <p className='aboutBottomText aboutDesktop strucMarginTop'>{aboutData.demarche.paragraphe_3}</p>
            <div className="aboutCitation aboutDesktop">
              <p>"{renderHighlightedQuote(aboutData.demarche.quote)}"</p>
            </div>
          </div>
        </div>

        {/* Separator */}
        <div className="TitleWrapper">
          <img src={separatorLogo} className="Logo" alt="" />
          <div className="liner"></div>
        </div>

        {/* Notre univers section */}
        <div className="aboutUnivers">
          <h3 className="aboutSectionTitle">{aboutData.univers.title}</h3>
          <p className="aboutUniversIntro">{aboutData.univers.intro}</p>
          <ul className="aboutUniversList">
            {aboutData.univers.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <p className="aboutUniversOutro">{aboutData.univers.outro}</p>
          <div className="aboutCitation">
            <p>"{renderHighlightedQuote(aboutData.univers.quote)}"</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutContent;
